module.exports = __webpack_public_path__ + "static/media/cloud_3.0114ecf9.png";